import firebase from 'firebase/app';
import 'firebase/auth';
import "firebase/firestore";

const configProd = {
  apiKey: "AIzaSyA4MezQFmg2N_ap3B7j7elNgECUoEN7IcE",
  authDomain: "mobilizei.firebaseapp.com",
  databaseURL: "https://mobilizei.firebaseio.com",
  projectId: "mobilizei",
  storageBucket: "mobilizei.appspot.com",
  messagingSenderId: "58249794297",
  appId: "1:58249794297:web:7518965398880a2b9f8828"
};

const configDev = {
  apiKey: "AIzaSyARmBuXf-tlt_gOFFCE28aMzkvmPlimLGs",
  authDomain: "mobilizei-development.firebaseapp.com",
  databaseURL: "https://mobilizei-development.firebaseio.com",
  projectId: "mobilizei-development",
  storageBucket: "mobilizei-development.appspot.com",
  messagingSenderId: "214620005771",
  appId: "1:214620005771:web:85023547b51ee64042bb8e"
};

class Firebase {
  constructor() {
    if (!firebase.apps.length) {
      firebase.initializeApp(process.env.REACT_APP_ENV === 'prod' ? configProd : configDev);
    }

    this.auth = firebase.auth();
    this.db = firebase.firestore();
  }

  // *** Auth API ***

  doSignInWithEmailAndPassword = (email, password) =>
    this.auth.signInWithEmailAndPassword(email, password)
      .then(() => {
        window.localStorage.setItem('email', email);
        window.localStorage.setItem('password', password);
      })

  doSignOut = () => this.auth.signOut().then(() => window.localStorage.clear());

  doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

  doPasswordUpdate = password =>
    this.auth.currentUser.updatePassword(password);

  onAuthUserListener = (next, fallback) =>
    this.auth.onAuthStateChanged(authUser => {
      if (authUser) {
        authUser.getIdTokenResult()
          .then(idTokenResult => {
            // Add role to authUser
            authUser = {
              uid: authUser.uid,
              email: authUser.email,
              role: idTokenResult.claims.role
            };

            next(authUser);
          });
      } else {
        fallback();
      }
    });

  getStores = () => {
    return this.stores().get()
      .then(snapshot => {
        if (snapshot.empty) {
          return [];
        }

        let stores = [];

        snapshot.forEach(doc => {
          stores.push({
            id: doc.id,
            ...doc.data()
          })
        });

        return stores;
      }).catch(() => {
        return [];
      })
  }

  updateStore = (storeId, data) => {
    return this.stores().doc(storeId).update(data);
  }
  
  stores = () => this.db.collection("platforms").doc("convertr").collection("stores");
}

export default Firebase;